import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const useGlobalStore = create(
  devtools(
    persist(
      (set) => ({
        // Company preferences state
        companyPreferences: null,

        // Actions for company preferences
        setCompanyPreferences: (preferences) => 
          set(
            { companyPreferences: preferences },
            false,
            'set-company-preferences'
          ),

        // Clear all global state (useful for logout)
        clearGlobalState: () => 
          set(
            { companyPreferences: null },
            false,
            'clear-global-state'
          ),
      }),
      {
        name: 'global-storage',
        partialize: (state) => ({ 
          companyPreferences: state.companyPreferences 
        }), // Only persist company preferences
      }
    ),
    {
      name: 'global-store', // Name for devtools
    }
  )
);

export default useGlobalStore; 